module.exports = __webpack_public_path__ + "img/casino-wm.31aebd17.jpg";